import rem from '../utils/rem';
import { IRadius } from './IRadius';

export const radii: IRadius = {
  small: rem(8),
};
